import { jsxs as r, jsx as o } from "react/jsx-runtime";
const i = (e) => /* @__PURE__ */ r("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ o("path", { d: "M14.3281 4.67188L19.3281 9.67188", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M8 20.9996L2 21.9996L3 15.9996L16.414 2.58557C16.7891 2.21063 17.2977 2 17.828 2C18.3583 2 18.8669 2.21063 19.242 2.58557L21.414 4.75757C21.7889 5.13263 21.9996 5.64124 21.9996 6.17157C21.9996 6.7019 21.7889 7.21052 21.414 7.58557L8 20.9996Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
] });
export {
  i as default
};
//# sourceMappingURL=edit.js.map
